<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="contratoResponsables">
      <template v-slot:[`item.principal`]="{ item }">
        {{ item.principal ? 'Si' : 'No'}}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrarResponsableContrato(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CONTRATO_RESPONSABLES from '@/graphql/querys/administracion/contratos/responsables/contratoResponsables.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoResponsablesContratoDesktop',
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'funcionario.nombre',
        },
        { text: 'Es Residente?', value: 'principal' },
        {
          text: '', align: 'end', width: '150', value: 'acciones',
        },
      ],
      idContrato: this.$route.params.idContrato,
    };
  },
  methods: {
    borrarResponsableContrato(responsableContrato) {
      eventBus.$emit('borrar-responsable-contrato', responsableContrato);
    },
  },
  apollo: {
    contratoResponsables: {
      query: CONTRATO_RESPONSABLES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
};
</script>

<style lang="scss">
</style>
